import { render, staticRenderFns } from "./guangzhousms.vue?vue&type=template&id=4996bda6&scoped=true"
import script from "./guangzhousms.vue?vue&type=script&lang=js"
export * from "./guangzhousms.vue?vue&type=script&lang=js"
import style0 from "./guangzhousms.vue?vue&type=style&index=0&id=4996bda6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4996bda6",
  null
  
)

export default component.exports